import { AllowedKeyType } from "core/remotes";
import { Observable } from "rxjs";

export interface IControlLoadOptions<TModel extends any> {

  skip?: number,
  take?: number,
  searchValue?: string

}

export interface IControlDataSourceConfig<TModel extends any = any, TKeyType extends AllowedKeyType = string> {

  keyField: string
  byKey?: (key: TKeyType) => Observable<TModel>
  load: (loadOptions?: IControlLoadOptions<TModel>) => Observable<TModel[]>
  quickInsert?: (value: string) => Observable<any>
  loadAll?: (loadOptions: IControlLoadOptions<TModel>) => Observable<TModel[]>

}

export class ControlDataSource<TModel extends any = any, TKeyType extends AllowedKeyType = string> implements IControlDataSourceConfig<TModel, TKeyType> {

  readonly keyField: string
  readonly byKey?: (key: TKeyType) => Observable<TModel>
  readonly load: (loadOptions?: IControlLoadOptions<TModel>) => Observable<TModel[]>
  readonly quickInsert?: (value: string) => Observable<any>
  readonly loadAll?: (loadOptions: IControlLoadOptions<TModel>) => Observable<TModel[]>

  constructor(config: IControlDataSourceConfig<TModel, TKeyType>) {

    this.keyField = config.keyField;
    this.load = config.load;
    this.byKey = config.byKey;
    this.quickInsert = config.quickInsert;
    this.loadAll = config.loadAll;

  }

}
